import Common from './Common';

export default class Payment {
    static getBraintreeToken() {
        const params = {
            url: `/v1/braintree-client-token`,
            method: 'get'
        };
        return Common.request(params);
    }

    static createStripeSetupIntent() {
        const params = {
            url: `/v1/payment/stripe/setup-intent`,
            method: 'post'
        };
        return Common.request(params);
    }

    static createStripePaymentIntent(data) {
        const params = {
            url: `/v1/payment/stripe/payment-intent`,
            method: 'post',
            data
        };
        return Common.request(params);
    }
}
